import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MealFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M16.0833 22.2715C15.5215 22.2715 14.9898 22.0508 14.5885 21.6495C14.1772 21.2482 13.9665 20.7166 13.9665 20.1447L14.0568 3.57218C14.0568 2.94018 14.2976 2.3784 14.7089 2.04735C15.07 1.76645 15.5215 1.66614 16.003 1.76645C18.3404 2.23795 19.9856 4.27441 20.1863 6.9529L20.6277 12.7011C20.6879 13.4636 20.685 14.4877 20.4684 14.8406C20.2519 15.1936 19.6533 15.2427 18.2501 15.1589C17.578 15.1188 17.4476 15.1489 17.3974 15.2693C17.1266 15.8712 17.568 17.4361 17.8589 18.4594C17.9993 18.951 18.1197 19.4024 18.1899 19.7435C18.3003 20.3654 18.1398 21.0075 17.7285 21.489C17.3172 21.9806 16.7253 22.2615 16.0933 22.2715H16.0833Z"
				fill="currentColor"
			/>
			<path
				d="M6.88918 22.2715C6.35749 22.2715 5.8559 22.0608 5.48472 21.6796C5.11354 21.2984 4.91291 20.7868 4.93297 20.2551L5.23393 11.397C5.23393 11.1462 5.14364 10.9054 4.9731 10.7248L4.79253 10.5342C4.05017 9.77182 3.33887 8.7586 3.33887 7.69523V7.64507L3.3489 3.22104C3.3489 2.80974 3.74241 2.46866 4.15371 2.46866C4.56502 2.46866 4.95367 2.80974 4.95367 3.22104V6.89269H6.04371V3.92327C6.04371 3.51196 6.4879 3.06852 6.89921 3.06852C7.31051 3.06852 7.75371 3.51196 7.75371 3.92327V6.89269H8.84474V3.22104C8.84474 2.80974 9.23241 2.46866 9.64371 2.46866C10.055 2.46866 10.4537 2.80974 10.4537 3.22104V7.69523C10.4537 8.7586 9.73821 9.77182 8.99586 10.5342L8.81528 10.7148C8.64474 10.8954 8.54442 11.1361 8.55446 11.3869L8.85541 20.245C8.87547 20.7767 8.67484 21.2883 8.30366 21.6695C7.93248 22.0508 7.43089 22.2715 6.89921 22.2715H6.88918Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MealFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MealFilledIcon;
